import styled from 'styled-components';

export const InfoRelatedContainer = styled.div`
  position: relative;
  border: 1px solid #c5d9e5;
  border-radius: 0.5rem;
  padding: 0.8rem;
  width: 24%;
  overflow: hidden;
  background-color: #fff;
`;
